module.exports = __webpack_public_path__ + "static/media/twitter.64c341fa.svg";